import http from '@/common/utils/http'

/** 获取故障列表 */
export function searchFaultList(data) {
  return http({
    url: `fault/searchFaultList`,
    method: 'post',
    data
  })
}